import { Observable } from 'rxjs';
import {Wishlist} from '../wishlist.model';


export abstract class CustomWishlistAdapter {

  abstract loadWishlist(userId: string): Observable<Wishlist>;
  abstract createWishlist(
    userId: string,
    productCode?: string,
  ): Observable<Wishlist>;

  abstract deleteWishlist(userId: string, productCode: string): Observable<any>;
}
